var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSample = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m18.552 10.208.552.552a.785.785 0 1 0 1.11-1.11l-5.55-5.55a.785.785 0 0 0-1.111 1.11l.558.557-.002.001-3.328 3.329h-.003l-6.662 6.661a3.142 3.142 0 0 0 4.442 4.443l9.992-9.992zm-5.55-1.111h4.436L15.22 6.878zm8.194 7.006a1.57 1.57 0 1 1-3.14 0c0-.867.785-2.355 1.57-3.14.785.785 1.57 2.273 1.57 3.14m-.504-.752c.055.184.079.367.084.536.017.512-.29.626-.36.118a3.4 3.4 0 0 0-.108-.533 3.5 3.5 0 0 0-.206-.512c-.221-.458.1-.534.366-.1.088.143.169.308.224.492",
  clipRule: "evenodd"
})));
export default SvgSample;